module.exports = __webpack_public_path__ + "assets/img/nzz.18149b52.png";